import React, { useState, useEffect, useRef } from 'react';
import 'animate.css';
import secbox from '../../Assests/images/home_images/co-own-space-about-img1.webp';
import secbox2 from '../../Assests/images/home_images/co-own-space-about-img2.webp';
import AnimatedContent from '../Common/AnimatedContent';
import { motion } from "framer-motion";
import { useInView } from 'react-intersection-observer'; 
import { LazyLoadImage } from 'react-lazy-load-image-component';


const BoxTeam = () => {
  const [isVisible, setIsVisible] = useState(false);
  const cardRef = useRef(null);
  const boxTeamRef = useRef(null);

 
  useEffect(() => {
    if (window.location.hash === "#aboutus") {
      boxTeamRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const currentCard = cardRef.current;

    if (currentCard) {
      observer.observe(currentCard);
    }

    return () => {
      if (currentCard) observer.unobserve(currentCard);
    };
  }, []);
  const textVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: { delay: i * 0.05, duration: 0.3, ease: "easeOut" },
    }),
  };
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
  const text = "About CoOwnSpace";
  const characters = text.split("");

  return (
    <section ref={boxTeamRef} id="aboutus" className="section-box-team style-2 tf-spacing-1 pb-0">
      <div className="tf-container">
        <div className="row">
          <div className="col-lg-6">
            <div className="content-inner">
              <div className="heading-section mb-48">
              <h2 ref={ref} className="title text-start balance">
                  {characters.map((char, i) => (
                    <motion.span
                      key={i}
                      className="inline-block"
                      variants={textVariants}
                      initial="hidden"
                      animate={inView ? "visible" : "hidden"}
                      custom={i}
                    >
                      {char}
                    </motion.span>
                  ))}
                </h2>
              </div>
              <div className="content mb-48 animate__fadeInUp animate__animated">
                <AnimatedContent
                  distance={25}
                  direction="vertical"
                  reverse={false}
                  config={{ tension: 80, friction: 20 }}
                  initialOpacity={0.2}
                  animateOpacity
                  scale={1.1}
                  threshold={0.2}
                >
                  <p className="text-1 description-1 mb-16">
                    Welcome to CoOwnSpace, your trusted partner in fractional ownership and real estate investment.
                    We believe that everyone deserves the opportunity to own a piece of their dream property without
                    the financial burden of full ownership.
                  </p>
                  <p className="description-2 text-1 mb-24">
                    At CoOwnSpace, we empower individuals to invest in premium properties through shared ownership,
                    making real estate more accessible, affordable, and rewarding. Our innovative platform is designed
                    to provide transparency, security, and seamless investment opportunities tailored to your goals.
                  </p>
                  <p className="description-3 text-1 mb-24">
                    Whether you're looking to diversify your portfolio or step into the world of real estate, CoOwnSpace
                    is here to guide you every step of the way. Together, let’s build a future where property ownership
                    is within everyone’s reach.
                  </p>
                  <h3 className="title text-h3">CoOwnSpace – Own Smart, Invest Together.</h3>
                </AnimatedContent>
              </div>
            </div>
          </div>
          <div className="col-lg-6 pb-5">
            <div className="wrap-image relative">
              <div
                ref={cardRef}
                className={`image-wrap hover-img-wrap img-1 ${isVisible ? 'animate__animated animate__zoomIn' : ''}`}
              >
                <LazyLoadImage className="about-img1 lazyload parallax-img" src={secbox} alt="CoOwnSpaceImage 1" loading="lazy" />
              </div>
              <div
                className={`image-wrap hover-img-wrap img-2 ${isVisible ? 'animate__animated animate__zoomIn' : ''}`}
              >
                <LazyLoadImage className="about-img2 lazyload parallax-img" src={secbox2} alt="CoOwnSpaceImage 2" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BoxTeam;
